// extracted by mini-css-extract-plugin
export var sliderRange = "_nb-2";
export var sliderRoot = "_nb-0";
export var sliderThumb = "_nb-3";
export var sliderTrack = "_nb-1";